import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-train-configuration',
  templateUrl: './train-configuration.component.html',
  styleUrls: ['./train-configuration.component.scss']
})
export class TrainConfigurationComponent implements OnInit {
  @Input() trainData: any;
  @Output() deleteTrain = new EventEmitter<any>();
  @Output() editTrain = new EventEmitter<any>();
  @Output() copyTrain = new EventEmitter<any>();
  @Output() addTrainPartEvent: EventEmitter<any> = new EventEmitter();
  @Output() deleteTrainPartEvent: EventEmitter<any> = new EventEmitter();
  @Output() swapTrainPartPlacesEvent: EventEmitter<any> = new EventEmitter();
  @Output() rotateTrainPartEvent: EventEmitter<any> = new EventEmitter();
  @Output() editTrainPartEvent: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() {
  }

  edit() {
    this.editTrain.emit(this.trainData);
  }

  delete() {
    this.deleteTrain.emit(this.trainData.id);
  }

  copy() {
    this.copyTrain.emit({ trainId: this.trainData.id, trainName: 'Copy of ' + this.trainData.name });
  }

  addTrainPart(index: number) {
    this.addTrainPartEvent.emit({ index: index, train: this.trainData })
  }

  deleteTrainPart(wagonId: number) {
    this.deleteTrainPartEvent.emit({ wagonId: wagonId, trainId: this.trainData.id })
  }

  swapTrainPart(index: number) {
    this.swapTrainPartPlacesEvent.emit({ index: index, trainId: this.trainData.id })
  }

  rotateTrainPart(wagonId: number) {
    this.rotateTrainPartEvent.emit({ wagonId: wagonId, trainId: this.trainData.id })
  }

  editTrainPart(wagonData: any) {
    this.editTrainPartEvent.emit({ wagon: wagonData, trainId: this.trainData.id })
  }
}